export class OpsUser {
    id: string;
    name: string;
    password: string;
    permissions: OpsUserCategory[];
    isAdmin: boolean;
    index?: number;
    sessionTimeout?: number;
    createdAt?: Date;
    updatedAt?: Date;
}

export class OpsUserCategory {
    id: string;
    category: string;
    OpsUserCategories: any[];
    editChannel: boolean;
    controlMimic: boolean;
}

export const CATEGORY_MAX_LEN = 15;
export const ELLIPSIS = '…';
